import "./style.scss";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import $ from "jquery";
import 'slick-carousel';
import "slick-carousel/slick/slick.scss";

gsap.registerPlugin(ScrollTrigger);

function initProductsIntro() {
    const section = document.querySelector(".wp-block-ow-products");
    if (!section) {
        return;
    }

    const intro = section.querySelector(".products__content-intro");
    const pattern = section.querySelector(".products__pattern");
    const textFirst = section.querySelector(".text-first");
    const textSecond = section.querySelector(".text-second");
    const repeater = section.querySelector(".products__content-repeater");

    if (!intro) {
        return;
    }

    // Initialize Slick slider
    if (repeater) {
        const $repeater = $(repeater);

        $repeater.slick({
            dots: false,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 3L5 8L10 13" stroke="#00594E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">  <path d="M6 3L11 8L6 13" stroke="#00594E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            infinite: true,
            speed: 1,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            cssEase: "linear",
            useCSS: false,
        });

        $repeater.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
            const $slides = $repeater.find(".slick-slide");
            const $currentItem = $(slick.$slides[currentSlide]);
            const $nextItem = $(slick.$slides[nextSlide]);
            const totalSlides = slick.slideCount;

            // Detect direction from indices
            let dir = "next";
            if (
                (nextSlide < currentSlide && !(currentSlide === totalSlides - 1 && nextSlide === 0)) ||
                (currentSlide === 0 && nextSlide === totalSlides - 1)
            ) {
                dir = "prev";
            }

            const clipFrom = dir === "next"
                ? "inset(0% 0% 0% 100%)"
                : "inset(0% 100% 0% 0%)";

            gsap.killTweensOf([$currentItem[0], $nextItem[0]]);

            // Remove classes from all slides
            $slides.removeClass("is-current is-incoming");

            // Add classes
            $currentItem.addClass("is-current");
            $nextItem.addClass("is-incoming");

            // Get inner elements of both slides
            const currentText = $currentItem.find(".products__inner-text")[0];
            const currentBadge = $currentItem.find(".products__badge")[0];
            const currentPicture = $currentItem.find(".products__inner-picture")[0];
            const currentDecoration = $currentItem.find(".products__inner-decoration")[0];

            const nextText = $nextItem.find(".products__inner-text")[0];
            const nextBadge = $nextItem.find(".products__badge")[0];
            const nextPicture = $nextItem.find(".products__inner-picture")[0];
            const nextDecoration = $nextItem.find(".products__inner-decoration")[0];

            const offsetX = dir === "next" ? 80 : -80;

            gsap.set($currentItem[0], {
                clipPath: "inset(0% 0% 0% 0%)",
            });

            gsap.set($nextItem[0], {
                clipPath: clipFrom,
            });

            // Set initial states for NEXT slide elements
            if (nextText) {
                gsap.set(nextText, {x: offsetX, opacity: 0});
            }
            if (nextBadge) {
                gsap.set(nextBadge, {x: offsetX, opacity: 0});
            }
            if (nextPicture) {
                gsap.set(nextPicture, {rotation: dir === "next" ? 25 : -25});
            }
            if (nextDecoration) {
                gsap.set(nextDecoration, {rotation: dir === "next" ? 14 : -14, scale: 0.8, y: 80});
            }

            // Animate CURRENT slide elements OUT
            if (currentText) {
                gsap.to(currentText, {
                    x: -offsetX,
                    opacity: 0,
                    duration: 0.5,
                    ease: "power2.in",
                });
            }
            if (currentBadge) {
                gsap.to(currentBadge, {
                    x: -offsetX,
                    opacity: 0,
                    duration: 0.5,
                    ease: "power2.in",
                });
            }
            if (currentPicture) {
                gsap.to(currentPicture, {
                    rotation: dir === "next" ? -8 : 8,
                    duration: 0.5,
                    ease: "power2.in",
                });
            }
            if (currentDecoration) {
                gsap.to(currentDecoration, {
                    rotation: dir === "next" ? -12 : 12,
                    scale: 0.8,
                    duration: 0.5,
                    ease: "power2.in",
                });
            }

            // Animate clip-path
            gsap.to($nextItem[0], {
                clipPath: "inset(0% 0% 0% 0%)",
                duration: 0.6,
                ease: "none",
            });

            // Animate NEXT slide elements IN
            if (nextText) {
                gsap.to(nextText, {
                    x: 0,
                    opacity: 1,
                    duration: 0.6,
                    delay: 0.15,
                    ease: "power2.out",
                });
            }
            if (nextBadge) {
                gsap.to(nextBadge, {
                    x: 0,
                    opacity: 1,
                    duration: 0.6,
                    delay: 0.2,
                    ease: "power2.out",
                });
            }
            if (nextPicture) {
                gsap.to(nextPicture, {
                    rotation: 0,
                    duration: 0.8,
                    delay: 0.1,
                    ease: "power2.out",
                });
            }
            if (nextDecoration) {
                gsap.to(nextDecoration, {
                    rotation: 0,
                    scale: 1,
                    y: 0,
                    duration: 0.8,
                    delay: 0.1,
                    ease: "power2.out",
                });
            }

            gsap.delayedCall(0.8, function () {
                $slides.removeClass("is-current is-incoming");
                // Reset current slide elements for next use
                if (currentText) {
                    gsap.set(currentText, {x: 0, opacity: 1});
                }
                if (currentBadge) {
                    gsap.set(currentBadge, {x: 0, opacity: 1});
                }
                if (currentPicture) {
                    gsap.set(currentPicture, {rotation: 0});
                }
                if (currentDecoration) {
                    gsap.set(currentDecoration, {rotation: 0, scale: 1});
                }
            });
        });
    }

    // Initial states
    gsap.set(pattern, {opacity: 0, scale: 1});
    gsap.set(textFirst, {x: () => -window.innerWidth});
    gsap.set(textSecond, {x: () => window.innerWidth});
    gsap.set(repeater, {clipPath: "inset(50% 50% 50% 50%)"});

    // Pin the whole section
    ScrollTrigger.create({
        trigger: section,
        start: "top top",
        end: "+=200%",
        pin: true,
    });

    gsap.timeline({
        scrollTrigger: {
            trigger: section,
            start: "top center",
            end: "+=200%",
            scrub: 1,
        },
    })
        // Phase 1: Both texts slide in simultaneously
        .to(textFirst, {
            x: 0,
            duration: 0.7,
            ease: "none",
        }, 0)

        .to(textSecond, {
            x: 0,
            duration: 0.7,
            ease: "none",
        }, 0)

        .to(pattern, {
            opacity: 1,
            scale: 1.2,
            duration: 0.7,
            ease: "none",
        }, 0)

        // Phase 2: Texts spread apart + fade out
        .to(textFirst, {
            x: () => window.innerWidth,
            duration: 0.7,
            ease: "none",
        }, 0.7)
        .to(textSecond, {
            x: () => -window.innerWidth,
            duration: 0.7,
            ease: "none",
        }, 0.7)
        .fromTo(repeater, {
            clipPath: "inset(50% 50% 50% 50% round 24px)",
        }, {
            clipPath: "inset(0% 0% 0% 0% round 24px)",
            duration: 0.7,
            ease: "none",
        }, 0.75);
}

document.addEventListener("DOMContentLoaded", initProductsIntro);

document.addEventListener('DOMContentLoaded', () => {
    const popupWrapper = document.querySelector('.popup-wrapper');
    if (!popupWrapper) {
        return;
    }

    const triggers = document.querySelectorAll('.js-popup-trigger');
    const closeBtn = popupWrapper.querySelector('.popup-close-button');
    const allInners = popupWrapper.querySelectorAll('.popup-inner');

    triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
            const targetId = trigger.dataset.popupTarget;

            // Hide all inner panels first
            allInners.forEach((inner) => inner.classList.remove('is-active'));

            // Show the matching one
            const targetInner = popupWrapper.querySelector(
                `[data-popup-id="${targetId}"]`
            );
            if (targetInner) {
                targetInner.classList.add('is-active');
            }

            popupWrapper.classList.add('is-active');
        });
    });

    // Close on X button
    closeBtn.addEventListener('click', () => {
        popupWrapper.classList.remove('is-active');
    });

    // Close on backdrop click
    popupWrapper.addEventListener('click', (e) => {
        if (e.target === popupWrapper) {
            popupWrapper.classList.remove('is-active');
        }
    });
});